import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";

/* ---------------- Styled Components ---------------- */
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Ocupa a altura total da viewport */
  background-color: var(--gray-50); /* Usando Design Token */
  padding: 1rem;
  width: 100%; /* Garante que o wrapper ocupe 100% da largura */
`;

const Box = styled.div`
  background-color: white; /* bg-white */
  border-radius: var(--radius); /* Usando Design Token */
  padding: 3rem 2rem; /* Equivalente a 48px 32px, usando rem */
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  max-width: 480px;
  width: 100%;
  text-align: center;
  display: flex; /* Adicionado para layout flex */
  flex-direction: column; /* Para empilhar a logo, título, subtítulo e botão */
  align-items: center; /* Para centralizar os itens horizontalmente */
  gap: 1rem; /* Espaçamento entre os elementos internos do Box */
`;

const LogoImage = styled.img`
  height: 2rem; /* h-8 */
  margin-bottom: 1rem; /* Espaçamento da logo para o título */
`;

const Title = styled.h1`
  font-size: var(--fs-h1); /* Usando Design Token */
  font-weight: 800;
  color: var(--text-900); /* Usando Design Token */
  /* Removi margin-bottom daqui, pois o gap do Box fará o espaçamento */
`;

const Subtitle = styled.p`
  /* Ajustado margin-top/bottom pois o gap do Box agora controla o espaçamento */
  margin: 0;
  font-size: var(--fs-body); /* Usando Design Token */
  color: var(--gray-700); /* Usando Design Token */
`;

const Button = styled.button`
  background-color: var(--brand-500); /* Usando Design Token */
  color: white;
  border: none;
  border-radius: var(--radius); /* Usando Design Token */
  padding: 0.75rem 1.5rem; /* Equivalente a 12px 24px, usando rem */
  font-weight: 600;
  font-size: var(--fs-body); /* Usando Design Token */
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 1rem; /* Adicionado um margin-top para o botão ter espaçamento adequado com o Subtitle */

  &:hover {
    background-color: var(--brand-600); /* Usando Design Token */
  }
`;

/* ---------------- Component ---------------- */
export default function NotFound() {
    const navigate = useNavigate();

    const handleBackHome = () => {
        // Remove a URL inválida do histórico
        navigate("/", { replace: true });
    };

    return (
        <Wrapper>
            <Box>
                <LogoImage src="/logo-vidas.png" alt="Vidas" /> {/* Logo centralizada */}
                <Title>404</Title>
                <Subtitle>Página não encontrada ou acesso não autorizado.</Subtitle>
                <Button onClick={handleBackHome}>Voltar para o início</Button>
            </Box>
        </Wrapper>
    );
}